import { useEffect, useState } from "react";
import { useAccountSettings } from "../../context/AccountSettingsContext";
import { useFormContext } from "react-hook-form";
import { ConsultCEP } from "../../../services/Address.service";

export const useAccountBilling = () => {
    const {scope, STATES} = useAccountSettings();
    const [documentLabel, setDocumentLabel] = useState('CPF/CNPJ');
    const [states] = useState(STATES);
    const form = useFormContext();
    const billingTypeValue = form.watch('accountBilling.billingType');
    const [canEdit, setCanEdit] = useState(true);

    const billingTypeValues = [
        {value: 'individual', label: 'Pessoa Física'},
        {value: 'company', label: 'Pessoa Jurídica'}
      ]

      console.log('canEdit', canEdit);
      console.log('scope', scope);
      console.log('id', form.watch('accountBilling.id'));

    useEffect(() => {
        if(billingTypeValue === 'company'){
          setDocumentLabel('CNPJ');
        } else if(billingTypeValue === 'individual'){
          setDocumentLabel('CPF');
        }

        if(scope != 'alderaan' && !!form.watch('accountBilling.id')){
            setCanEdit(false);
        } else {
            setCanEdit(true);
        }
      }, [billingTypeValue]);

      const updateAddressFromZipcode = () => {
        const zipcodeValue = form.watch('accountBilling.zipcode');
        if(zipcodeValue && zipcodeValue.length === 9){
          ConsultCEP(zipcodeValue).then((response) => {
            form.setValue('accountBilling.neighborhood', response.neighborhood);
            form.setValue('accountBilling.addressLine1', response.street);
            form.setValue('accountBilling.city', response.city);
            form.setValue('accountBilling.state', response.state);
          });
        }
      }

    return {
        documentLabel,
        setDocumentLabel,
        updateAddressFromZipcode,
        form,
        scope,
        states,
        billingTypeValues,
        billingTypeValue,
        canEdit
    }
}